import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { SalesforceMarketingCloudObjectDataset } from 'app/model/dataset/salesforce-marketing-cloud-object.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'SalesforceMarketingCloudSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(SalesforceMarketingCloudObjectDataset) }
})
export class SalesforceMarketingCloudCopySource extends TabularCopySource {
}
